import React from 'react'
import { ButtonLoadingSeeker } from '@ui-seeker/core'
import { areCommonFiltersValid } from '@signals/commonFilters/filters'
import { Box } from '@mui/material'
import { useToast } from '@hooks'
import { isSearching } from 'Pages/RealTimeHistory/RealTime/@signals'
import { isLoadingCommonFilters } from '@signals'


export default function RealTimeFiltersFooterActions() {

	const { showToast } = useToast()

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-around", gap: 1, my: 1 }}>
		<ButtonLoadingSeeker
			sx={{ px: 4 }}
			disabled={!isSearching.value}
			onClick={() => {
				isSearching.value = false
				showToast.info("Stopping Search!")
			}}
		>
			Stop Search
		</ButtonLoadingSeeker>
		<ButtonLoadingSeeker
			loading={isSearching.value || isLoadingCommonFilters.value}
			sx={{ px: 4 }}
			onClick={() => {
				isLoadingCommonFilters.value = true
			}}
			disabled={!areCommonFiltersValid.value || isSearching.value || isLoadingCommonFilters.value}
		>
			Search
		</ButtonLoadingSeeker>
	</Box>
}